import * as React from "react";

import "./basemap-gallery-toggle.scss";
import {Button, Header, Image} from "semantic-ui-react";
import {BasemapGalleryItemData} from "../basemap-gallery-item/basemap-gallery-item.data";
import {Icon} from "../../icon/icon";

export interface BasemapGalleryToggleProps {
    activeBasemapId: string;
    isLoading: boolean;
    mapToggle: BasemapGalleryItemData[];
    onClick: any;
}

export class BasemapGalleryToggle extends React.Component<BasemapGalleryToggleProps, any> {

    constructor(props: BasemapGalleryToggleProps) {
        super(props);
    }

    render(): JSX.Element {
        const {activeBasemapId, isLoading, mapToggle, onClick} = this.props;
        if(isLoading){
            return (
                <Button
                    className="geo-component geo-widget geo-popup--shadow geo-basemap-gallery-toggle"
                    loading={isLoading}
                    icon="map"
                />
            );
        }
        const btnClass = "geo-component geo-widget geo-basemap-gallery-toggle"
            + " geo-basemap-" + ((activeBasemapId === mapToggle[1].id)? "second": "first");
        return (
            <Button
                className={btnClass}
                onClick={onClick}>
                <div className={(mapToggle[0].isOrthophoto)? "geo-button-orthophoto":""}>
                    <div>
                        {mapToggle[0].thumbnailUrl? <Image src={mapToggle[0].thumbnailUrl} />: <Icon name="map" />}
                        <Header as="h4">Hintergrund</Header>
                    </div>
                </div>
                <div className={(mapToggle[1].isOrthophoto)? "geo-button-orthophoto":""}>
                    <div>
                        {mapToggle[1].thumbnailUrl? <Image src={mapToggle[1].thumbnailUrl} />: <Icon name="map" />}
                        <Header as="h4">Hintergrund</Header>
                    </div>
                </div>
            </Button>
        );
    }
}
